import { SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from '~/utils/const';

export const sToHM = (n) => {
  const h = parseInt(String(n / SECONDS_IN_HOUR));
  const m = parseInt(String((n % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE));
  return [h, m];
};
